const ENVIRONMENTS = ["production", "development"];

function roomUrl(room) {
  const url = room?.url;
  return typeof url === "string" && url.trim().length > 0 ? url : null;
}

function copyDefaultRoom(room) {
  if (!room || typeof room !== "object") {
    return null;
  }
  return {
    id: room.id ?? null,
    runtime_room_id: room.runtime_room_id ?? null,
    url: room.url ?? null,
    status: room.status ?? null,
    visibility: room.visibility ?? null
  };
}

export function defaultRoomUrls(project) {
  return {
    production: roomUrl(project?.default_rooms?.production),
    development: roomUrl(project?.default_rooms?.development)
  };
}

export function reconcileProjectDefaultRooms(project, deployments) {
  const defaultRooms = {
    production: copyDefaultRoom(project?.default_rooms?.production),
    development: copyDefaultRoom(project?.default_rooms?.development)
  };

  if (Array.isArray(deployments)) {
    for (const deployment of deployments) {
      const environmentKey = deployment?.environmentKey;
      if (deployment?.targetKey !== "room" || !ENVIRONMENTS.includes(environmentKey)) {
        continue;
      }
      defaultRooms[environmentKey] = copyDefaultRoom(deployment.default_room);
    }
  }

  return {
    ...project,
    default_rooms: defaultRooms
  };
}
